<template>
  <div class="p15">
    <question-search
      v-model="pgData"
      @search="handleSearch"
      type="question"
      titlePlaceholder="请输入内容"
      btntext="搜索"
      ref="search"
    >
      <div slot="time"></div>
    </question-search>
    <!-- chatGpt弹窗 -->
    <div class="chatGptBox"></div>
    <div class="left-list" v-loading="pageLoading">
      <layout-card style="padding: 0">
        <div v-if="tableData.length">
          <List-item
            class="item pt20 pb20 bbf2"
            v-for="(item, index) in tableData"
            :key="index"
            :data="item"
            :title="pgData.title"
            :state="state"
            type="question"
            @share="share"
            v-czc="[
              '每日一问',
              '点击列表',
              '每日一问列表',
              index + 1,
              'everydayQuestion',
            ]"
          >
          </List-item>
        </div>

        <empty-list v-else>
          <span>暂无数据</span>
        </empty-list>
        <my-pagination
          ref="page"
          v-model="tableData"
          :action="`${$store.state.api.webUrl}/question/espglist.json`"
          :loading.sync="pageLoading"
          :search="pgData"
          @currentChange="currentChange"
        ></my-pagination>
      </layout-card>
    </div>
  </div>
</template>
<script>
import LayoutCard from "@components/sys/layout-card";
import loadList from "../components/loadList";
import ListItem from "../components/list-item";
import EmptyList from "@components/sys/empty-list";
import QuestionSearch from "./questionSearch";
export default {
  components: {
    LayoutCard,
    ListItem,
    loadList,
    EmptyList,
    QuestionSearch,
  },
  data() {
    return {
      pgData: {
        pageIndex: 1,
        pageSize: 10,
        sortOrder: "ASC",
        title: "",
        sortName: "",
      },
      title: "",
      state: false,
      tableData: [],
      pageLoading: false,
    };
  },
  mounted() {},
  methods: {
    handleSearch(data) {
      if (data) {
        this.pgData.title = data;
        this.title = data;
      }
      if (this.pgData.title) {
        this.state = true;
      }
      this.$emit("advance", this.pgData.title ? false : true); //控制每日一问头部图片是否显示
      this.pgData.pageIndex = 1;
      this.$refs.search.getTitle(data);
      if (this.$refs.page) {
        this.$refs.page.queryData();
      }
    },
    share(data) {
      if (data == true) {
        this.$refs.question.queryData();
      }
    },
    currentChange(val) {
      this.setCzc([
        "每日一问",
        "翻页",
        "文件列表",
        val.nowPage,
        "everydayQuestion-page-everydayQuestionList",
      ]);
    },
  },
};
</script>
<style scoped>
.left-list {
  min-height: 500px;
}
</style>
